module.exports = __webpack_public_path__ + "img/Goofram.45a73553.png";